<template>
    <article v-if="item !== null" class="breaker" :class="getModuleThemeClass()">
        <div v-if="item.RichText != ''" class="breaker__content rich-text" v-html="item.RichText"></div>
        <image-component v-if="item.Image.Image.Path" :image="item.Image" module-name="breaker" :sizes="getSizeParameters()"></image-component>
    </article>
</template>
<script>
import ImageComponent from '../components/image-component.vue';
import { useItem } from '../composables/item';
const { getThemeClass } = useItem();

export default {
    name: 'Breaker',
    components: {
        ImageComponent
    },
    props: {
        item: {
            type: Object,
            default: null
        },
        modalHasNavigation: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        getModuleThemeClass() {
            return getThemeClass(this.item);
        },
        getSizeParameters() {
            return [
                {
                    breakpoint: '1920',
                    width: this.modalHasNavigation ? '1232' : '1800',
                    compression: 100
                },
                {
                    breakpoint: '992',
                    width: this.modalHasNavigation ? '1195' : '1727',
                    compression: 100
                },
                {
                    breakpoint: '480',
                    width: this.modalHasNavigation ? '595' : '892',
                    compression: 100
                },
                {
                    default: true,
                    width: '459',
                    compression: 100
                }
            ];
        },
    }
};
</script>
